import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/assets/(asset)/$assetId/workspace/records/$recordId/workspace/assets/$relatedAssetId/_drawer/activity",
)({
	/** Tab body is composed by the drawer layout into Figma `Details`. */
	component: () => null,
});
